var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"support-page"},[_c('base-container',[_c('div',{staticClass:"support-page-inner"},[_c('custom-title',{attrs:{"header_tag":"h1","type":"h1","title":_vm.translate.title,"subtitle":_vm.translate.subtitle,"use-string":true}}),_c('support-form')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }